import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    display: ${displayState?.display ?? ''};
    flex-direction: ${displayState?.flexDirection ?? ''};
    height: ${`${displayState?.height ? displayState?.height+'px' : '' }`};
    width: ${`${displayState?.width}` ?? ''};
    max-height: ${`${displayState?.maxHeight ? displayState?.maxHeight+'px' : '' }`};
  `}
`;

export default Wrapper(template);
